document.addEventListener('DOMContentLoaded', () => {
    (function () {
        const STRATS = window.SA_BUNDLE_STRATS || [];
        const SPY_URL =
            'https://raw.githubusercontent.com/SaCapitalManagement/CapitalManagementLtd/main/public_json/spybenchmark.json';

        const STRAT_COLORS = ['#004cff', '#10b981', '#f59e0b', '#8b5cf6', '#ef4444'];
        const SPY_COLOR = '#71717a';
        const NORM_START = 100000;

        const loadingEl = () => document.getElementById('loading');

        const commonTooltip = {
            trigger: 'axis',
            backgroundColor: '#ffffff',
            borderColor: '#e3e8ee',
            borderWidth: 1,
            padding: 12,
            textStyle: { color: '#1a1f36', fontSize: 13, fontFamily: 'Inter' },
            extraCssText:
                'box-shadow: 0 2px 5px 0 rgba(60,66,87,0.1),0 1px 1px 0 rgba(0,0,0,0.07);border-radius:4px;z-index:50;min-width:220px;',
            formatter: function (params) {
                const date = new Date(params[0].name);
                const dateStr = date.toLocaleDateString('en-US', {
                    weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
                });
                let html = `<div style="font-weight:600;font-size:13px;color:#1a1f36;margin-bottom:10px;padding-bottom:8px;border-bottom:1px solid #e3e8ee">${dateStr}</div><div style="display:flex;flex-direction:column;gap:8px">`;
                params.forEach((p) => {
                    if (p.value == null) return;
                    const val = '$' + p.value.toLocaleString(undefined, { maximumFractionDigits: 0 });
                    html += `<div style="display:flex;align-items:center;justify-content:space-between;gap:20px"><div style="display:flex;align-items:center;gap:8px"><div style="width:8px;height:8px;border-radius:50%;background:${p.color}"></div><div style="font-size:12px;color:#697386">${p.seriesName}</div></div><div style="font-size:12px;font-weight:600;color:#1a1f36">${val}</div></div>`;
                });
                return html + '</div>';
            },
        };

        function normDate(s) {
            if (!s) return null;
            const str = String(s).trim();
            if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
            const mdy = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
            if (mdy) {
                let [_, m, d, y] = mdy;
                m = m.padStart(2, '0'); d = d.padStart(2, '0');
                if (y.length === 2) y = (parseInt(y) < 50 ? '20' : '19') + y;
                return `${y}-${m}-${d}`;
            }
            const dmy = str.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
            if (dmy) { const [_, d, m, y] = dmy; return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`; }
            const dt = new Date(str);
            if (isNaN(dt.getTime())) return null;
            return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
        }

        function parseEquityMap(json) {
            const map = new Map();
            const data = Array.isArray(json) ? json : (json.equity || []);
            data.forEach((r) => {
                const d = normDate(r.Date);
                if (d) map.set(d, parseFloat(r.Equity));
            });
            return map;
        }

        function calculateStats(equityCurve, dates) {
            if (!equityCurve || equityCurve.length < 2) return null;
            const dailyReturns = [];
            const yearRets = new Map();
            for (let i = 1; i < equityCurve.length; i++) {
                const prev = equityCurve[i - 1], curr = equityCurve[i];
                const r = prev > 0 ? (curr - prev) / prev : 0;
                dailyReturns.push(r);
                const year = parseInt(dates[i].split('-')[0]);
                if (!yearRets.has(year)) yearRets.set(year, []);
                yearRets.get(year).push(r);
            }
            const annualReturns = {};
            yearRets.forEach((rets, year) => { annualReturns[year] = rets.reduce((acc, r) => acc * (1 + r), 1) - 1; });
            const first = equityCurve[0], last = equityCurve[equityCurve.length - 1];
            const years = Math.max(dailyReturns.length / 252, 0.1);
            const cagr = first > 0 ? Math.pow(last / first, 1 / years) - 1 : 0;
            let peak = -Infinity, maxDrawdown = 0;
            for (const v of equityCurve) {
                if (v > peak) peak = v;
                const dd = peak > 0 ? (peak - v) / peak : 0;
                if (dd > maxDrawdown) maxDrawdown = dd;
            }
            const avg = dailyReturns.reduce((a, b) => a + b, 0) / dailyReturns.length;
            const sumSq = dailyReturns.reduce((a, b) => a + Math.pow(b - avg, 2), 0);
            const std = dailyReturns.length > 1 ? Math.sqrt(sumSq / (dailyReturns.length - 1)) : 0;
            const downReturns = dailyReturns.filter((r) => r < 0);
            const downStd = Math.sqrt(downReturns.reduce((a, b) => a + Math.pow(b, 2), 0) / (downReturns.length || 1));
            const sharpe = std > 0 ? (avg / std) * Math.sqrt(252) : 0;
            const sortino = downStd > 0 ? (avg / downStd) * Math.sqrt(252) : 0;
            const annVals = Object.values(annualReturns);
            const mar = maxDrawdown > 0 ? cagr / maxDrawdown : 0;
            return {
                cagr, sharpe, sortino, maxDrawdown, mar,
                totalReturn: first > 0 ? (last - first) / first : 0,
                bestYear: annVals.length ? Math.max(...annVals) : 0,
                worstYear: annVals.length ? Math.min(...annVals) : 0,
                annualReturns,
            };
        }

        function pearsonCorr(a, b) {
            const n = Math.min(a.length, b.length);
            if (n < 2) return 0;
            const ma = a.slice(0, n).reduce((s, v) => s + v, 0) / n;
            const mb = b.slice(0, n).reduce((s, v) => s + v, 0) / n;
            let num = 0, da2 = 0, db2 = 0;
            for (let i = 0; i < n; i++) {
                const da = a[i] - ma, db = b[i] - mb;
                num += da * db; da2 += da * da; db2 += db * db;
            }
            return da2 === 0 || db2 === 0 ? 0 : num / Math.sqrt(da2 * db2);
        }

        function getDailyReturns(map, dates) {
            const rets = [];
            for (let i = 1; i < dates.length; i++) {
                const prev = map.get(dates[i - 1]), curr = map.get(dates[i]);
                rets.push(prev && prev > 0 ? (curr - prev) / prev : 0);
            }
            return rets;
        }

        async function init() {
            const el = loadingEl();
            try {
                if (STRATS.length === 0) {
                    console.warn('SA Bundle: SA_BUNDLE_STRATS is empty. Add s1_handle through s4_handle metafields to the bundle product in Shopify admin.');
                    return;
                }

                const fetches = [
                    fetch(SPY_URL).then((r) => r.json()).catch(() => null),
                    ...STRATS.map((s) => fetch(s.url).then((r) => r.json()).catch(() => null)),
                ];
                const [spRes, ...stratResults] = await Promise.all(fetches);

                if (!spRes && stratResults.every((r) => !r)) return;

                const spMap = spRes ? parseEquityMap(spRes) : new Map();
                const stratMaps = stratResults.map((r) => r ? parseEquityMap(r) : null);
                const stratJsonStats = stratResults.map((r) => r && !Array.isArray(r) && r.stats ? r.stats : null);

                const allDates = new Set();
                stratMaps.filter(Boolean).forEach((m) => m.forEach((_, d) => allDates.add(d)));
                const sortedDates = Array.from(allDates).sort();

                if (sortedDates.length < 10) return;

                const normalizedMaps = stratMaps.map((m) => {
                    if (!m) return null;
                    const stratDates = Array.from(m.keys()).sort();
                    const base = m.get(stratDates[0]) || 1;
                    const norm = new Map();
                    sortedDates.forEach((d) => {
                        const raw = m.get(d);
                        if (raw != null) norm.set(d, raw * (NORM_START / base));
                    });
                    return norm;
                });

                const individualEqs = normalizedMaps.map((m) =>
                    m ? sortedDates.map((d) => m.has(d) ? m.get(d) : null) : null
                );

                let spBase = spMap.get(sortedDates[0]);
                if (!spBase) {
                    const spKeys = Array.from(spMap.keys()).sort();
                    const firstKey = spKeys.find((d) => d >= sortedDates[0]);
                    spBase = firstKey ? spMap.get(firstKey) : NORM_START;
                }
                const spyEq = sortedDates.map((d) => (spMap.get(d) || spBase) * (NORM_START / spBase));

                const individualStats = normalizedMaps.map((m) => {
                    if (!m) return null;
                    const stratDates = sortedDates.filter((d) => m.has(d));
                    const stratEq = stratDates.map((d) => m.get(d));
                    return calculateStats(stratEq, stratDates);
                });
                const spyStats = calculateStats(spyEq, sortedDates);

                const availMaps = normalizedMaps.filter(Boolean);
                const commonDates = sortedDates.filter((d) => availMaps.every((m) => m.has(d)));
                const stratReturns = availMaps.map((m) => getDailyReturns(m, commonDates));
                const corrMatrix = stratReturns.map((a, i) =>
                    stratReturns.map((b, j) => i === j ? 1 : parseFloat(pearsonCorr(a, b).toFixed(3)))
                );

                render(sortedDates, individualEqs, spyEq, individualStats, spyStats, corrMatrix, stratJsonStats);

                lucide.createIcons();

            } catch (e) {
                console.error('SA Bundle Error:', e);
            } finally {
                if (el) el.style.display = 'none';
            }
        }

        function render(dates, individualEqs, spyEq, indvStats, spyStats, corrMatrix, stratJsonStats) {
            const fmtPct = (n) => n == null ? '-' : (n * 100).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '%';
            const fmtNum = (n) => n == null ? '-' : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            // Overlay JSON stats (Expectancy, MaxExposure, MAR, etc.) from each strategy's JSON file
            if (stratJsonStats) {
                stratJsonStats.forEach((js, i) => {
                    if (!js || !indvStats[i]) return;
                    const st = indvStats[i];
                    if (js.Sharpe) st.sharpe = js.Sharpe;
                    if (js.Drawdown) st.maxDrawdown = Math.abs(js.Drawdown) / 100;
                    if (js.Expectancy) st.expectancy_val = js.Expectancy;
                    if (js.MAR) st.mar = js.MAR;
                    if (js.MaxExposure) st.exposure = js.MaxExposure;
                    if (js.NetProfit !== undefined) st.netProfit = js.NetProfit;
                    if (js.Trades !== undefined) st.trades = js.Trades;
                    if (js.PctWins !== undefined) st.pctWins = js.PctWins;
                });
            }

            const validStats = indvStats.filter(Boolean);

            // Hero stats: avg CAGR / avg Sharpe / avg Max DD
            const heroEl = document.getElementById('sa-bundle-hero-stats');
            if (heroEl && validStats.length && spyStats) {
                const avgCAGR = validStats.reduce((a, s) => a + s.cagr, 0) / validStats.length;
                const avgSharpe = validStats.reduce((a, s) => a + s.sharpe, 0) / validStats.length;
                const avgDD = validStats.reduce((a, s) => a + s.maxDrawdown, 0) / validStats.length;

                const getDiff = (p, s, isDD = false) => {
                    if (!isFinite(p) || !isFinite(s) || Math.abs(s) < 0.0001) return '';
                    const d = isDD
                        ? ((Math.abs(s) - Math.abs(p)) / Math.abs(s)) * 100
                        : ((p - s) / Math.abs(s)) * 100;
                    if (!isFinite(d)) return '';
                    return `<div class="sa-badge-stat ${d >= 0 ? 'sa-bg-green-100' : 'sa-bg-red-50'}" style="padding:2px 6px;border-radius:4px;font-size:11px;font-weight:700;white-space:nowrap">${d >= 0 ? '+' : ''}${Math.round(d)}%</div>`;
                };

                heroEl.innerHTML = [
                    { label: 'Avg CAGR', sub: 'across included strategies', val: fmtPct(avgCAGR), spy: fmtPct(spyStats.cagr), diff: getDiff(avgCAGR, spyStats.cagr) },
                    { label: 'Avg Sharpe Ratio', sub: 'across included strategies', val: fmtNum(avgSharpe), spy: fmtNum(spyStats.sharpe), diff: getDiff(avgSharpe, spyStats.sharpe) },
                    { label: 'Avg Max Drawdown', sub: 'across included strategies', val: '-' + fmtPct(avgDD), spy: '-' + fmtPct(spyStats.maxDrawdown), diff: getDiff(avgDD, spyStats.maxDrawdown, true) },
                ].map((m) => `
                <div class="sa-card-sm">
                    <div class="sa-flex sa-justify-between" style="margin-bottom:0.25rem">
                        <p style="font-size:11px;font-weight:500;color:#6b7280;margin:0">${m.label}</p>
                        ${m.diff}
                    </div>
                    <p style="font-size:11px;color:#9ca3af;margin:0 0 0.25rem 0">${m.sub}</p>
                    <p style="font-size:22px;font-weight:700;color:#111827;margin:0" class="tab-num">${m.val}</p>
                    <p style="font-size:11px;font-weight:500;color:#6b7280;margin:0" class="tab-num">SPY ${m.spy}</p>
                </div>`).join('');
            }

            // Equity chart
            const chartEl = document.getElementById('sa-bundle-equity-chart');
            if (chartEl) {
                const skip = Math.ceil(dates.length / 800);
                const dSub = dates.filter((_, i) => i % skip === 0 || i === dates.length - 1);
                const spSub = spyEq.filter((_, i) => i % skip === 0 || i === dates.length - 1);

                const series = [];
                STRATS.forEach((strat, i) => {
                    const eq = individualEqs[i];
                    if (!eq) return;
                    const subEq = eq.filter((_, idx) => idx % skip === 0 || idx === dates.length - 1);
                    const color = STRAT_COLORS[i] || STRAT_COLORS[0];
                    series.push({
                        name: strat.short_name || strat.name,
                        type: 'line',
                        data: subEq,
                        showSymbol: false,
                        connectNulls: false,
                        lineStyle: { width: 2, color },
                        itemStyle: { color },
                        z: 3 + i,
                    });
                });
                series.push({
                    name: 'SPY ETF',
                    type: 'line',
                    data: spSub,
                    showSymbol: false,
                    lineStyle: { width: 1.5, color: SPY_COLOR },
                    itemStyle: { color: SPY_COLOR },
                    z: 2,
                });

                const eqChart = echarts.init(chartEl);
                eqChart.setOption({
                    animation: true,
                    animationDuration: 1800,
                    animationEasing: 'exponentialOut',
                    tooltip: commonTooltip,
                    legend: { bottom: 0, icon: 'circle', itemGap: 16, textStyle: { fontSize: 11 } },
                    grid: { top: 20, left: 10, right: 10, bottom: 70, containLabel: true },
                    xAxis: {
                        type: 'category', data: dSub, boundaryGap: false,
                        axisLabel: {
                            interval: (idx) => idx % Math.ceil(dSub.length / 12) === 0,
                            formatter: (v) => "'" + v.slice(2, 4),
                            color: '#697386', fontSize: 11,
                        },
                        axisLine: { show: false }, axisTick: { show: false },
                        splitLine: { show: true, lineStyle: { type: 'dashed', color: '#e3e8ee' } },
                    },
                    yAxis: {
                        type: 'log', min: 'dataMin', max: 'dataMax',
                        axisLabel: {
                            formatter: (v) => v >= 1e6 ? '$' + (v / 1e6).toFixed(1) + 'M' : '$' + (v / 1000).toFixed(0) + 'k',
                            color: '#697386', fontSize: 11,
                        },
                        axisLine: { show: false }, axisTick: { show: false },
                        splitLine: { show: true, lineStyle: { type: 'dashed', color: '#e3e8ee' } },
                    },
                    series,
                });

                // Add live pulse dots after animation
                setTimeout(() => {
                    const pulseSeries = [
                        ...Array(STRATS.length + 1).fill({}), // placeholders for existing line series
                        ...STRATS.map((strat, i) => {
                            const eq = individualEqs[i];
                            if (!eq) return null;
                            const subEq = eq.filter((_, idx) => idx % skip === 0 || idx === dates.length - 1);
                            const lastVal = subEq[subEq.length - 1];
                            if (lastVal == null) return null;
                            const color = STRAT_COLORS[i] || STRAT_COLORS[0];
                            return {
                                id: 'pulse_' + i,
                                type: 'effectScatter',
                                coordinateSystem: 'cartesian2d',
                                data: [[dSub.length - 1, lastVal]],
                                symbolSize: 7,
                                showEffectOn: 'render',
                                rippleEffect: { brushType: 'stroke', scale: 3, period: 4 },
                                itemStyle: { color, shadowBlur: 8, shadowColor: color },
                                zlevel: 5,
                                tooltip: { show: false },
                            };
                        }).filter(Boolean),
                        {
                            id: 'pulse_spy',
                            type: 'effectScatter',
                            coordinateSystem: 'cartesian2d',
                            data: [[dSub.length - 1, spSub[spSub.length - 1]]],
                            symbolSize: 6,
                            showEffectOn: 'render',
                            rippleEffect: { brushType: 'stroke', scale: 3, period: 4, opacity: 0.5 },
                            itemStyle: { color: SPY_COLOR, shadowBlur: 4, shadowColor: SPY_COLOR },
                            zlevel: 5,
                            tooltip: { show: false },
                        },
                    ];
                    eqChart.setOption({ series: pulseSeries });
                }, 1900);

                window.addEventListener('resize', () => eqChart.resize());
            }

            // Drawdown chart
            const ddChartEl = document.getElementById('sa-bundle-dd-chart');
            if (ddChartEl) {
                const skipD = Math.ceil(dates.length / 800);
                const dSubD = dates.filter((_, idx) => idx % skipD === 0 || idx === dates.length - 1);

                const ddSeries = [];
                STRATS.forEach((strat, i) => {
                    const eq = individualEqs[i];
                    if (!eq) return;
                    const color = STRAT_COLORS[i] || STRAT_COLORS[0];
                    const dd = [];
                    let pk = -Infinity;
                    eq.forEach((v) => {
                        if (v != null && v > pk) pk = v;
                        dd.push(v != null && pk > 0 ? ((v - pk) / pk) * 100 : null);
                    });
                    const ddSub = dd.filter((_, idx) => idx % skipD === 0 || idx === dates.length - 1);
                    ddSeries.push({
                        name: strat.short_name || strat.name,
                        type: 'line',
                        data: ddSub,
                        showSymbol: false,
                        connectNulls: false,
                        lineStyle: { width: 1.5, color },
                        areaStyle: { color, opacity: 0.07 },
                        itemStyle: { color },
                        z: 3 + i,
                    });
                });

                const spDd = [];
                let spPk = -Infinity;
                spyEq.forEach((v) => {
                    if (v > spPk) spPk = v;
                    spDd.push(spPk > 0 ? ((v - spPk) / spPk) * 100 : 0);
                });
                const spDdSub = spDd.filter((_, idx) => idx % skipD === 0 || idx === dates.length - 1);
                ddSeries.push({
                    name: 'SPY ETF',
                    type: 'line',
                    data: spDdSub,
                    showSymbol: false,
                    lineStyle: { width: 1.5, color: SPY_COLOR },
                    itemStyle: { color: SPY_COLOR },
                    z: 2,
                });

                const ddChart = echarts.init(ddChartEl);
                ddChart.setOption({
                    animation: true,
                    animationDuration: 1200,
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: '#ffffff',
                        borderColor: '#e3e8ee',
                        borderWidth: 1,
                        padding: 10,
                        textStyle: { color: '#1a1f36', fontSize: 12, fontFamily: 'Inter' },
                        extraCssText: 'box-shadow:0 2px 5px rgba(60,66,87,0.1);border-radius:4px;z-index:50',
                        formatter: function (params) {
                            const date = new Date(params[0].name);
                            const dateStr = date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
                            let html = `<div style="font-weight:600;font-size:12px;color:#1a1f36;margin-bottom:8px">${dateStr}</div>`;
                            params.forEach((p) => {
                                if (p.value == null) return;
                                html += `<div style="display:flex;align-items:center;justify-content:space-between;gap:12px"><span style="display:flex;align-items:center;gap:4px"><span style="width:6px;height:6px;border-radius:50%;background:${p.color};display:inline-block"></span><span style="font-size:11px;color:#697386">${p.seriesName}</span></span><span style="font-size:11px;font-weight:600;color:#dc2626">${p.value.toFixed(1)}%</span></div>`;
                            });
                            return html;
                        },
                    },
                    legend: { bottom: 0, icon: 'circle', itemGap: 16, textStyle: { fontSize: 11 } },
                    grid: { top: 8, left: 10, right: 10, bottom: 60, containLabel: true },
                    xAxis: {
                        type: 'category', data: dSubD, boundaryGap: false,
                        axisLabel: {
                            interval: (idx) => idx % Math.ceil(dSubD.length / 12) === 0,
                            formatter: (v) => "'" + v.slice(2, 4),
                            color: '#697386', fontSize: 11,
                        },
                        axisLine: { show: false }, axisTick: { show: false },
                        splitLine: { show: true, lineStyle: { type: 'dashed', color: '#e3e8ee' } },
                    },
                    yAxis: {
                        type: 'value', max: 0,
                        axisLabel: { formatter: (v) => v.toFixed(0) + '%', color: '#697386', fontSize: 11 },
                        axisLine: { show: false }, axisTick: { show: false },
                        splitLine: { show: true, lineStyle: { type: 'dashed', color: '#e3e8ee' } },
                    },
                    series: ddSeries,
                });
                window.addEventListener('resize', () => ddChart.resize());
            }

            // Correlation matrix — HTML table matching portfolio tool design
            const corrEl = document.getElementById('sa-bundle-correlation');
            if (corrEl && corrMatrix.length > 1) {
                const names = STRATS.map((s) => s.short_name || s.name.replace('RealTest ', ''));

                const getCellStyle = (v, isDiag) => {
                    if (isDiag) return 'background:#f9fafb;color:#d1d5db';
                    if (v >= 0.7) return 'background:#ffffff;color:#dc2626;border:1px solid #fecaca';
                    if (v <= 0.3) return 'background:#86efac;color:#14532d';
                    if (v <= 0.5) return 'background:#bbf7d0;color:#14532d';
                    return 'background:#dcfce7;color:#166534';
                };

                corrEl.innerHTML = `
                <div style="background:white;border-radius:8px;border:1px solid #e3e8ee;overflow:hidden">
                    <div style="overflow-x:auto">
                        <table style="width:100%;font-size:11px;border-collapse:collapse">
                            <thead>
                                <tr style="background:#f9fafb;border-bottom:1px solid #e3e8ee">
                                    <th style="text-align:left;font-weight:500;color:#6b7280;padding:10px 16px">Strategy</th>
                                    ${names.map((n) => `<th style="text-align:center;font-weight:500;color:#6b7280;padding:10px 8px;min-width:56px">${n.length > 10 ? n.slice(0, 9) + '…' : n}</th>`).join('')}
                                </tr>
                            </thead>
                            <tbody>
                                ${corrMatrix.map((row, i) => `
                                <tr style="border-bottom:1px solid #f3f4f6">
                                    <td style="color:#374151;font-weight:500;padding:10px 16px;white-space:nowrap;font-size:12px">${names[i]}</td>
                                    ${row.map((v, j) => `<td style="text-align:center;font-weight:600;padding:10px 8px;font-variant-numeric:tabular-nums;${getCellStyle(v, i === j)}">${i === j ? '-' : v.toFixed(2)}</td>`).join('')}
                                </tr>`).join('')}
                            </tbody>
                        </table>
                    </div>
                </div>`;
            }

            // Metrics comparison table
            const tableEl = document.getElementById('sa-bundle-metrics-table');
            if (tableEl && validStats.length && spyStats) {
                const shortNames = STRATS.map((s) => s.short_name || s.name.replace('RealTest ', ''));
                const metrics = [
                    { label: 'CAGR', fn: (s) => fmtPct(s.cagr) },
                    { label: 'Sharpe', fn: (s) => fmtNum(s.sharpe) },
                    { label: 'Sortino', fn: (s) => fmtNum(s.sortino) },
                    { label: 'MAR', fn: (s) => fmtNum(s.mar) },
                    { label: 'Net Profit', fn: (s) => fmtPct(s.totalReturn) },
                    { label: 'Expectancy', fn: (s) => s.expectancy_val !== undefined ? fmtNum(s.expectancy_val) : '-' },
                    { label: 'Max Exposure', fn: (s) => s.exposure !== undefined ? s.exposure + '%' : '-' },
                    { label: 'Max DD', fn: (s) => '-' + fmtPct(s.maxDrawdown) },
                    { label: 'Best Year', fn: (s) => fmtPct(s.bestYear) },
                    { label: 'Worst Year', fn: (s) => fmtPct(s.worstYear) },
                ];
                const stratCols = STRATS.map((strat, i) => ({
                    name: shortNames[i],
                    color: STRAT_COLORS[i] || STRAT_COLORS[0],
                    st: indvStats[i],
                })).filter((c) => c.st);

                tableEl.innerHTML = `
                <thead>
                    <tr>
                        <th style="border-top:none;font-size:11px">Metric</th>
                        ${stratCols.map((c) => `<th style="text-align:right;border-top:none;font-size:10px;max-width:80px"><span style="color:${c.color};font-weight:700">●</span> ${c.name}</th>`).join('')}
                        <th style="text-align:right;border-top:none;font-size:10px;color:#9ca3af">SPY</th>
                    </tr>
                </thead>
                <tbody>
                    ${metrics.map((m) => `<tr>
                        <td style="font-size:12px">${m.label}</td>
                        ${stratCols.map((c) => `<td style="text-align:right;font-weight:700;font-size:12px">${m.fn(c.st)}</td>`).join('')}
                        <td style="text-align:right;color:#6b7280;font-size:12px">${m.fn(spyStats)}</td>
                    </tr>`).join('')}
                </tbody>`;
            }

            // Statistical Edge Verification
            const verifyEl = document.getElementById('sa-bundle-verify');
            if (verifyEl && corrMatrix.length > 1) {
                const allCorrs = [];
                for (let i = 0; i < corrMatrix.length; i++)
                    for (let j = i + 1; j < corrMatrix.length; j++)
                        allCorrs.push(corrMatrix[i][j]);
                const avgCorr = allCorrs.reduce((a, b) => a + b, 0) / allCorrs.length;
                const maxCorr = Math.max(...allCorrs);
                const allBeatSpy = spyStats ? validStats.every((s) => s.cagr > spyStats.cagr) : false;

                const items = [
                    {
                        t: 'Low Pairwise Correlation',
                        d: `Avg ${avgCorr.toFixed(2)}, max ${maxCorr.toFixed(2)}. Strategies move independently`,
                        s: avgCorr < 0.5 ? 'Verified' : 'Moderate',
                        ok: avgCorr < 0.5,
                    },
                    {
                        t: `All ${STRATS.length} Strategies Beat SPY`,
                        d: allBeatSpy ? 'Every included strategy outperforms SPY on CAGR' : 'Check individual pages for benchmark comparison',
                        s: allBeatSpy ? 'Verified' : 'Check',
                        ok: allBeatSpy,
                    },
                    {
                        t: 'Distinct Strategy Styles',
                        d: STRATS.map((s) => s.style || s.universe).filter(Boolean).join(', ') || 'Multiple universes and timeframes',
                        s: 'Confirmed',
                        ok: true,
                    },
                    {
                        t: 'Live Portfolio Traded',
                        d: 'All strategies are actively traded in SetupAlpha live portfolio',
                        s: 'Verified',
                        ok: true,
                    },
                ];

                verifyEl.innerHTML = items.map((v) => `
                <div class="sa-flex sa-justify-between" style="padding-bottom:1rem;border-bottom:1px solid #f3f4f6">
                    <div>
                        <div style="font-weight:700;font-size:13px">${v.t}</div>
                        <div style="font-size:11px;color:#6b7280">${v.d}</div>
                    </div>
                    <div class="sa-badge-stat" style="background:${v.ok ? '#dcfce7' : '#eff6ff'};color:${v.ok ? '#166534' : '#1e40af'};white-space:nowrap;align-self:flex-start">${v.s}</div>
                </div>`).join('');
            }

            // Included strategy mini-cards
            const cardsEl = document.getElementById('sa-bundle-strategy-cards');
            if (cardsEl) {
                cardsEl.innerHTML = STRATS.map((strat, i) => {
                    const st = indvStats[i];
                    const color = STRAT_COLORS[i] || STRAT_COLORS[0];
                    return `
                    <a href="${strat.url_path}" target="_blank" style="text-decoration:none;display:block">
                        <div style="border:1px solid #e3e8ee;border-radius:8px;padding:0.875rem;cursor:pointer;transition:box-shadow 0.15s;background:white" onmouseover="this.style.boxShadow='0 2px 8px rgba(0,0,0,0.08)'" onmouseout="this.style.boxShadow='none'">
                            <div style="display:flex;align-items:flex-start;justify-content:space-between;gap:0.5rem;margin-bottom:0.625rem">
                                <div style="display:flex;align-items:center;gap:6px">
                                    <span style="width:8px;height:8px;border-radius:50%;background:${color};display:inline-block;flex-shrink:0"></span>
                                    <span style="font-weight:700;font-size:13px;color:#111827;line-height:1.3">${strat.name}</span>
                                </div>
                                <i data-lucide="external-link" style="width:12px;height:12px;color:#9ca3af;flex-shrink:0;margin-top:2px"></i>
                            </div>
                            <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:0.4rem">
                                <div>
                                    <div style="font-size:10px;color:#6b7280;font-weight:500;margin-bottom:1px">CAGR</div>
                                    <div style="font-size:13px;font-weight:700;color:#059669" class="tab-num">${st ? fmtPct(st.cagr) : '-'}</div>
                                </div>
                                <div>
                                    <div style="font-size:10px;color:#6b7280;font-weight:500;margin-bottom:1px">Max DD</div>
                                    <div style="font-size:13px;font-weight:700;color:#dc2626" class="tab-num">${st ? '-' + fmtPct(st.maxDrawdown) : '-'}</div>
                                </div>
                                <div>
                                    <div style="font-size:10px;color:#6b7280;font-weight:500;margin-bottom:1px">Sharpe</div>
                                    <div style="font-size:13px;font-weight:700;color:#374151" class="tab-num">${st ? fmtNum(st.sharpe) : '-'}</div>
                                </div>
                            </div>
                        </div>
                    </a>`;
                }).join('');
            }

            // Quick start guide — same pattern as single product page
            const guideEl = document.getElementById('sa-bundle-guide-list');
            if (guideEl) {
                guideEl.innerHTML = [
                    { t: 'You download all .rts files', d: 'Click Download after purchase' },
                    { t: 'You open each one in RealTest', d: 'File → Open → Select file' },
                    { t: 'You import symbols for each strategy', d: 'Click Import' },
                    { t: 'You run the backtest', d: 'Click Test' },
                ].map((s, i) => `
                <div style="display:flex;gap:0.75rem;align-items:flex-start">
                    <div style="width:1.5rem;height:1.5rem;background:#eff6ff;border-radius:99px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;color:#2563eb;flex-shrink:0;margin-top:2px">${i + 1}</div>
                    <div>
                        <div style="font-weight:700;font-size:14px;color:#374151;line-height:1.2">${s.t}</div>
                        <div style="font-size:12px;color:#6b7280;margin-top:2px">${s.d}</div>
                    </div>
                </div>`).join('');
            }

            // Live trading — same pattern as single product page
            const liveEl = document.getElementById('sa-bundle-live-list');
            if (liveEl) {
                liveEl.innerHTML = [
                    { t: 'Open OrderClerk', d: "Click 'Connect to IB'" },
                    { t: 'Import signals', d: "Click 'Import' in RealTest" },
                    { t: 'Generate orders', d: "Click 'Orders' in RealTest" },
                    { t: 'Execute trades', d: "Click 'Place Orders'" },
                ].map((s, i) => `
                <div style="display:flex;gap:0.75rem;align-items:flex-start">
                    <div style="width:1.5rem;height:1.5rem;background:#eff6ff;border-radius:99px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;color:#2563eb;flex-shrink:0;margin-top:2px">${i + 1}</div>
                    <div>
                        <div style="font-weight:700;font-size:14px;color:#374151;line-height:1.2">${s.t}</div>
                        <div style="font-size:12px;color:#6b7280;margin-top:2px">${s.d}</div>
                    </div>
                </div>`).join('');
            }

            // Strategies Overview — comparison table
            const overviewEl = document.getElementById('sa-bundle-strat-overview');
            if (overviewEl) {
                const shortNames = STRATS.map((s) => s.short_name || s.name.replace('RealTest ', ''));
                const attrRows = [
                    { l: 'Style', fn: (s) => s.style },
                    { l: 'Universe', fn: (s) => s.universe },
                    { l: 'Timeframe', fn: (s) => s.timeframe },
                    { l: 'Side', fn: (s) => s.side },
                    { l: 'Entry', fn: (s) => s.entry },
                    { l: 'Exit', fn: (s) => s.exit },
                    { l: 'Commission', fn: (s) => s.commission },
                    { l: 'Slippage', fn: (s) => s.slippage },
                    { l: 'Limit Price Buffer', fn: (s) => s.limitextra },
                ].filter((r) => STRATS.some((s) => r.fn(s)));

                const perfRows = [
                    { l: 'CAGR', fn: (st) => st ? fmtPct(st.cagr) : '-', color: (st) => '#059669' },
                    { l: 'Sharpe', fn: (st) => st ? fmtNum(st.sharpe) : '-', color: () => '#374151' },
                    { l: 'Max DD', fn: (st) => st ? '-' + fmtPct(st.maxDrawdown) : '-', color: () => '#dc2626' },
                ];

                const colW = `width:${Math.floor(80 / STRATS.length)}%`;

                const headerRow = `<tr style="background:#f9fafb;border-bottom:1px solid #e3e8ee">
                    <th style="text-align:left;font-weight:500;color:#9ca3af;padding:8px 14px;font-size:11px;width:20%"></th>
                    ${STRATS.map((strat, i) => {
                        const color = STRAT_COLORS[i] || STRAT_COLORS[0];
                        return `<th style="text-align:left;padding:8px 10px;${colW}">
                            <a href="${strat.url_path}" target="_blank" style="color:inherit;text-decoration:none;display:inline-flex;flex-direction:column;align-items:flex-start;gap:3px">
                                <span style="display:inline-flex;align-items:center;gap:3px">
                                    <span style="width:7px;height:7px;border-radius:50%;background:${color};display:inline-block;flex-shrink:0"></span>
                                    <i data-lucide="external-link" style="width:10px;height:10px;color:#9ca3af;flex-shrink:0"></i>
                                </span>
                                <span style="font-size:12px;font-weight:700;color:#111827;line-height:1.2">${shortNames[i]}</span>
                            </a>
                        </th>`;
                    }).join('')}
                </tr>`;

                const attrRowsHtml = attrRows.map((r, ri) => `
                <tr style="border-bottom:1px solid #f3f4f6">
                    <td style="font-size:11px;color:#9ca3af;font-weight:500;padding:7px 14px;white-space:nowrap">${r.l}</td>
                    ${STRATS.map((strat) => `<td style="text-align:left;font-size:12px;font-weight:600;color:#374151;padding:7px 10px">${r.fn(strat) || '-'}</td>`).join('')}
                </tr>`).join('');

                const dividerRow = `<tr style="background:#f9fafb;border-top:1px solid #e3e8ee;border-bottom:1px solid #e3e8ee">
                    <td colspan="${STRATS.length + 1}" style="font-size:10px;font-weight:600;color:#9ca3af;padding:5px 14px">Performance</td>
                </tr>`;

                const perfRowsHtml = perfRows.map((r, ri) => `
                <tr style="border-bottom:${ri === perfRows.length - 1 ? 'none' : '1px solid #f3f4f6'}">
                    <td style="font-size:11px;color:#9ca3af;font-weight:500;padding:7px 14px">${r.l}</td>
                    ${STRATS.map((strat, i) => {
                        const st = indvStats[i];
                        return `<td style="text-align:left;font-size:12px;font-weight:700;color:${r.color(st)};padding:7px 10px" class="tab-num">${r.fn(st)}</td>`;
                    }).join('')}
                </tr>`).join('');

                overviewEl.innerHTML = `<div style="background:white;border:1px solid #e3e8ee;border-radius:8px;overflow:hidden">
                    <div style="overflow-x:auto">
                        <table style="width:100%;border-collapse:collapse;font-size:12px">
                            <thead>${headerRow}</thead>
                            <tbody>${attrRowsHtml}${dividerRow}${perfRowsHtml}</tbody>
                        </table>
                    </div>
                </div>`;
            }
        }

        // AJAX Cart
        document.addEventListener('submit', (e) => {
            const form = e.target.closest('form[data-ajax-cart]');
            if (!form) return;
            e.preventDefault();
            e.stopPropagation();
            const formData = new FormData(form);
            const btn = form.querySelector('button[type="submit"]');
            if (!btn) return;
            const orig = btn.innerText;
            btn.innerText = 'Adding...';
            btn.disabled = true;
            const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
            fetch(root + 'cart/add.js', {
                method: 'POST',
                headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: formData.get('id'), quantity: 1, sections: 'cart-drawer,cart-icon-bubble' }),
            })
                .then((r) => r.json())
                .then((data) => {
                    btn.innerText = orig; btn.disabled = false;
                    if (data.status === 422) { alert(data.description || 'Error adding to cart.'); return; }
                    if (data.sections && data.sections['cart-icon-bubble']) {
                        const bubble = document.querySelector('#cart-icon-bubble');
                        if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
                    }
                    if (data.sections && data.sections['cart-drawer']) {
                        const existing = document.querySelector('cart-drawer');
                        if (existing) {
                            const html = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
                            const newInner = html.querySelector('cart-drawer');
                            if (newInner) existing.innerHTML = newInner.innerHTML;
                        }
                    }
                    const drawer = document.querySelector('cart-drawer');
                    if (drawer) {
                        if (typeof drawer.open === 'function') drawer.open();
                        else { drawer.setAttribute('open', ''); drawer.classList.add('active'); }
                    } else {
                        window.location.href = root + 'cart';
                    }
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                })
                .catch(() => { btn.innerText = orig; btn.disabled = false; window.location.href = root + 'cart'; });
        });

        init();
        document.addEventListener('shopify:section:load', init);
        document.addEventListener('shopify:section:select', init);
    })();
});
